import axios from 'axios'

const baseURL = 'https://control.zjwec.cn/api/v1'
// const baseURL = 'http://localhost:9998/api/v1'
const http = axios.create({
    baseURL: baseURL,
    timeout: 60000
})

// create中的参数是config
// 常见config项
// baseURL将自动加在 url 前面
// headers请求头，类型为简单对象
// params跟在 URL 后的请求参数，类型为简单对象或 URLSearchParams
// data请求体，类型有简单对象、FormData、URLSearchParams、File 等
// withCredentials跨域时是否携带 Cookie 等凭证，默认为 false，希望跨域请求携带 cookie，需要配置 withCredentials: true，服务器也要配置 allowCredentials = true，否则浏览器获取跨域返回的 cookie 时会报错
// responseType响应类型，默认为 json

// 请求拦截器

// 响应拦截器

// | 名称     | 含义     |
// | ------- | --------|
// | data    | 响应体数据|
// | status  | 状态码   |
// | headers | 响应头   |
//
// * 200 表示响应成功
// * 400 请求数据不正确 age=abc
//     * 401 身份验证没通过
// * 403 没有权限
// * 404 资源不存在
// * 405 不支持请求方式 post
// * 500 服务器内部错误

export default http



// WEBPACK FOOTER //
// ./src/api/axios.js